function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_450",
  "data-name": "Path 450",
  d: "M314.078,332.138c-.706.289-1.417.57-2.125.854.395-1.326-1.527-2.234-3.432-1.526-.424.158-.891.366-1.4.614.155-1.432-1.783-2.323-4.5-1.215-.66.269-4.676,2.5-6.051,3.112,2.327.67,4.58,2.228,4.1,5.016a3.814,3.814,0,0,1-3.618,3.387c-7.581.184-10.753.588-15.537-1.6-2.12-.97-3.361-2.948-4.238-5.061,8.278,5.218,10.12,4.624,19.649,4.392a1.492,1.492,0,0,0,1.435-1.514c.009-2.282-1.723-2.689-4.941-3.279-2.771-.508-5.106-.707-7.173-2.568-4.025-3.626-7.817-5.824-11.865-6.061s-8.229.87-13.381,3.875V345.41c1.819-.464,4.558-1.444,6.414-1.906a5.182,5.182,0,0,1,3.808.7c8.148,4.333,8.561,3.688,17.754,5.232a7.145,7.145,0,0,0,3.461-.195c11.558-3.566,12.536-4.565,24.217-11.883C320.466,334.966,318.135,330.481,314.078,332.138Z",
  transform: "translate(-240.996 -280.266)",
  fill: "#abb8c3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_451",
  "data-name": "Path 451",
  d: "M211.974,349.809V326.07a1.209,1.209,0,0,0-1.446-1.19L195,327.929v28.8l16.169-5.775A1.194,1.194,0,0,0,211.974,349.809Zm-9.7-1.571a2.425,2.425,0,1,1,2.425-2.425A2.425,2.425,0,0,1,202.274,348.238Z",
  transform: "translate(-195 -279.015)",
  fill: "#abb8c3"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Group_517",
  "data-name": "Group 517",
  transform: "translate(-1109 -589)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_32",
  "data-name": "Ellipse 32",
  cx: 5.845,
  cy: 5.845,
  r: 5.845,
  transform: "translate(1148 589)",
  fill: "#050358"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_454",
  "data-name": "Path 454",
  d: "M348.676,294.69a5.846,5.846,0,1,0-5.846-5.846A5.847,5.847,0,0,0,348.676,294.69Zm-2.573-4.827,1.156,0c.376,0,.206.465.454.777.314.39,1.587.315,1.912.092a.575.575,0,0,0,.037-.888c-.635-.524-2.254-.42-3.2-1.236-1.074-.927-.635-3.069,1.554-3.236.427-.033.088-.6.536-.6.356,0,.685-.069.684.324,0,.491.7.061,1.565.821.483.426.893,1.472.327,1.47l-1.068,0c-.335,0-.217-.351-.444-.62a2.113,2.113,0,0,0-1.83-.095.546.546,0,0,0-.018.837c.732.57,3.767.351,3.758,2.574,0,1.3-.893,1.925-2.167,2.048-.48.048-.018.792-.531.789-.6,0-.652.029-.65-.524,0-.509-.78-.042-1.723-.9a2.031,2.031,0,0,1-.632-1.332A.276.276,0,0,1,346.1,289.863Z",
  transform: "translate(805.17 306.002)",
  fill: "#4292ff"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Group_521",
  "data-name": "Group 521",
  transform: "translate(-1096 -577)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_32-2",
  "data-name": "Ellipse 32",
  cx: 6.685,
  cy: 6.685,
  r: 6.685,
  transform: "translate(1148 589)",
  fill: "#050358"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_454-2",
  "data-name": "Path 454",
  d: "M349.516,296.37a6.686,6.686,0,1,0-6.686-6.686A6.686,6.686,0,0,0,349.516,296.37Zm-2.943-5.521,1.322,0c.43,0,.235.532.52.889.359.446,1.815.36,2.187.105a.658.658,0,0,0,.043-1.015c-.726-.6-2.578-.48-3.657-1.414-1.228-1.06-.726-3.51,1.778-3.7.488-.038.1-.69.613-.688.407,0,.784-.079.782.37,0,.561.8.069,1.789.939.553.487,1.022,1.683.374,1.681l-1.221-.005c-.383,0-.248-.4-.508-.709a2.416,2.416,0,0,0-2.093-.108.624.624,0,0,0-.02.958c.838.652,4.308.4,4.3,2.944-.005,1.49-1.021,2.2-2.478,2.343-.548.055-.021.905-.607.9-.683,0-.746.033-.743-.6,0-.582-.892-.048-1.97-1.024a2.323,2.323,0,0,1-.723-1.524A.315.315,0,0,1,346.573,290.849Z",
  transform: "translate(805.17 306.002)",
  fill: "#4292ff"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "Group_522",
  "data-name": "Group 522",
  transform: "translate(-1115 -570)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_32-3",
  "data-name": "Ellipse 32",
  cx: 7.898,
  cy: 7.898,
  r: 7.898,
  transform: "translate(1148 589)",
  fill: "#050358"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_454-3",
  "data-name": "Path 454",
  d: "M350.729,298.8a7.9,7.9,0,1,0-7.9-7.9A7.9,7.9,0,0,0,350.729,298.8Zm-3.477-6.523,1.562.006c.509,0,.278.629.614,1.05.424.527,2.145.426,2.584.124a.777.777,0,0,0,.05-1.2c-.858-.708-3.046-.567-4.321-1.67-1.451-1.253-.858-4.147,2.1-4.373.577-.045.118-.815.724-.812.481,0,.926-.093.924.437,0,.663.948.082,2.114,1.109.653.575,1.207,1.989.442,1.986l-1.443-.006c-.453,0-.294-.474-.6-.837a2.854,2.854,0,0,0-2.473-.128.738.738,0,0,0-.024,1.132c.99.77,5.09.474,5.078,3.478-.006,1.761-1.206,2.6-2.928,2.768-.648.065-.025,1.07-.717,1.066-.807-.006-.881.04-.878-.708,0-.688-1.054-.056-2.328-1.21a2.744,2.744,0,0,1-.855-1.8A.372.372,0,0,1,347.253,292.274Z",
  transform: "translate(805.17 306.002)",
  fill: "#4292ff"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "Group_523",
  "data-name": "Group 523",
  transform: "translate(-1103 -556)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_32-4",
  "data-name": "Ellipse 32",
  cx: 8.563,
  cy: 8.563,
  r: 8.563,
  transform: "translate(1148 589)",
  fill: "#050358"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_454-4",
  "data-name": "Path 454",
  d: "M351.394,300.127a8.565,8.565,0,1,0-8.564-8.564A8.565,8.565,0,0,0,351.394,300.127Zm-3.77-7.072,1.694.006c.551,0,.3.682.666,1.138.46.572,2.325.462,2.8.135a.843.843,0,0,0,.054-1.3c-.93-.768-3.3-.615-4.685-1.811-1.573-1.358-.93-4.5,2.277-4.741.625-.049.128-.884.785-.881.521,0,1-.1,1,.474,0,.719,1.028.089,2.292,1.2.708.624,1.309,2.156.479,2.153l-1.564-.007c-.491,0-.318-.514-.65-.908a3.1,3.1,0,0,0-2.681-.139.8.8,0,0,0-.026,1.227c1.073.835,5.518.514,5.505,3.771-.007,1.909-1.308,2.821-3.174,3-.7.071-.027,1.16-.778,1.156-.875-.006-.955.043-.952-.768,0-.746-1.143-.061-2.524-1.312a2.976,2.976,0,0,1-.927-1.952A.4.4,0,0,1,347.625,293.055Z",
  transform: "translate(805.17 306.002)",
  fill: "#4292ff"
}));

var SvgConsumeCredit = function SvgConsumeCredit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_13_1",
    "data-name": "Component 13 \\u2013 1",
    width: 77.593,
    height: 77.711,
    viewBox: "0 0 77.593 77.711",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConsumeCredit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/consumeCredit.0b178630.svg";
export { ForwardRef as ReactComponent };